/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Typography, Link } from '@material-ui/core'

import Attachment from  '../../../Results/components/FileViewers/JSON/components/Attachment'

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class FlexDisplayLongText extends Component {
    state = {  }

    getParam = (param_name, value_type) => {
        let parameter = null

        if (this.props.instance.component_params !== null) {
            this.props.instance.component_params.map(param => {
                if (param.name === param_name) {
                    parameter = param.value[value_type]
                }
            })
        }

        return parameter
    }

    renderFieldValue = () => {
        if (this.props.instance.embedded_attachments) {
            if (this.props.instance.embedded_attachments.length === 0) {
                return (
                    <Typography style = {{whiteSpace : 'pre-wrap'}} variant = 'body2' dangerouslySetInnerHTML = {{__html : this.props.instance.value.text}}></Typography>
                )
            } else {
                console.log("FlexForm :: Attachments: ", this.props.instance)
                let value = this.props.instance.value.text.split(/(\[SAINAPSE_ATTACHMENT:[ A-Za-z0-9_@./#&+-]*\])/)
                console.log("FlexForm :: Embedded Attachments : ", value)
                let content = value.map(val => {
                    if (val[0] === '[' && val[val.length -1] === ']') {
                        let hash = val.substring(21, val.length -1)
                        let attachment_object = this.props.instance.embedded_attachments.find(attachment => attachment.inlineHash === hash)
                        if (attachment_object) {
                            if (attachment_object.file_wv_address !== null) {
                                let record = {
                                    iu_record_src_info : {
                                        iu_content_type : {
                                            sub_type : attachment_object.content_type
                                        },
                                        iu_record_nav_info : {
                                            location : {
                                                position : 1
                                            }
                                        }
                                    },
                                    source_link : {
                                        path : attachment_object.file_name
                                    }
                                }
                                return (
                                    <Attachment
                                        width = '33%'
                                        attachment = {attachment_object}
                                        show_title = {true}
                                        show_view = {true}
                                        server_name = {attachment_object.file_wv_address.wv_server_name}
                                        file_id = {attachment_object.file_wv_address.wv_id}
                                        file_name = {attachment_object.file_name}
                                        file_type = {attachment_object.content_type}
                                        path = {attachment_object.content_type}
                                        record = {record}
                                        drl_url = {this.props.drl_url}
                                        re_attach = {false}
                                        attach_options = {this.props.attach_options}
                                        re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
                                    />
                                )
                            } else if (attachment_object.link_info.type === "HYPERLINK") {
                                return (
                                    <Typography display = 'block' variant = 'body2' color = 'textPrimary'>
                                        <Link>{attachment_object.link_info.originalLink}</Link>
                                    </Typography>
                                )
                            } else {
                                return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Unable to fetch inline attachment</Typography>)
                            }
                        } else {
                            return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Unable to fetch inline attachment</Typography>)
                        }
                    } else {
                        return (
                            <Typography style = {{whiteSpace : 'pre-wrap'}} variant = 'body2' dangerouslySetInnerHTML = {{__html : val}}></Typography>
                        )
                    }
                })
                
                return content
            }
        } else {
            return (
                <Typography style = {{whiteSpace : 'pre-wrap'}} variant = 'body2' dangerouslySetInnerHTML = {{__html : this.props.instance.value.text}}></Typography>
            )
        }
    }

    render() { 
        console.log("Display Long Text : Value : ", this.props)
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', padding : '5px'}}>
                    <Typography variant = 'subtitle2' color = 'primary'>{this.getParam('label', 'text')}</Typography>
                    {this.renderFieldValue()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(FlexDisplayLongText);